import { Component } from "react";
import AppContext from "../components/AppContext";
import {
  isDevToolsOpen,
} from "../utils/devToolsChecker";
import { handleLogoutAndAlert } from "../utils"; // ฟังก์ชันสำหรับ logout และ alert
let devToolStatus = isDevToolsOpen();

class DevToolsBlocker extends Component {
  static contextType = AppContext;

  devToolsCheckTimer = null;

  // ตั้งค่าช่วงเวลาการตรวจสอบเป็น 1.30 นาที (90,000 มิลลิวินาที)
  CHECK_INTERVAL_MS = 60000;

  componentDidMount() {
    this.addProtectionListeners();
    // this.startPeriodicCheck();
  }

  componentWillUnmount() {
    this.removeProtectionListeners();
    // หยุดการตรวจสอบ DevTools เมื่อคอมโพเนนต์ถูกถอดออก
    this.stopPeriodicCheck();
  }

  // start
  startPeriodicCheck = () => {
    this.devToolsCheckTimer = setInterval(() => {
      // this.checkDevToolsStatus();
    }, this.CHECK_INTERVAL_MS);
  };

  // stop
  stopPeriodicCheck = () => {
    if (this.devToolsCheckTimer) {
      clearInterval(this.devToolsCheckTimer);
      this.devToolsCheckTimer = null;
    }
  };

  // Check Status Tools
  checkDevToolsStatus = () => {
    const { resProfileAdmin } = this.context;
    const isProgramer = resProfileAdmin?.admin_type === "programer";
    // true คือ เปิดอยู่

    // กำหนดข้อความแจ้งเตือน
    const msg = `DevTools เปิดอยู่และผู้ใช้ไม่ใช่โปรแกรมเมอร์ ออกจากระบบและ ปิด DevTools เพื่อใช้งานระบบ`;
    const titel = `แจ้งเตือนจากระบบ`;
    const icon = `warning`;

    if (devToolStatus && !isProgramer) {
      // ถ้า devToolStatus = true และ ไม่ใช่ programer ให้ออกจากระบบ
      this.stopPeriodicCheck();
      console.log(`DevTools: ${devToolStatus ? "Open" : "Close"}`);

      // การออกจากระบบ
      if (typeof handleLogoutAndAlert === "function") {
        handleLogoutAndAlert(msg, titel, icon);
      } else {
        console.error(
          "handleLogoutAndAlert is not defined or is not a function."
        );
      }
    }
  };

  addProtectionListeners = () => {
    document.addEventListener("contextmenu", this.handleContextMenu);
    document.addEventListener("keydown", this.handleKeyDown);
  };

  removeProtectionListeners = () => {
    document.removeEventListener("contextmenu", this.handleContextMenu);
    document.removeEventListener("keydown", this.handleKeyDown);
  };

  // บล็อกคลิกขวา ถ้าไม่ใช่ "programer"
  handleContextMenu = (e) => {
    const { resProfileAdmin } = this.context;
    const isProgramer = resProfileAdmin?.admin_type === "programer";

    if (!isProgramer) {
      e.preventDefault();
      console.warn("Right-click disabled.");
    }
  };

  // บล็อก F12 หรือ Ctrl+Shift+I  ถ้าไม่ใช่ "programer"
  handleKeyDown = (e) => {
    const { resProfileAdmin } = this.context;
    const i = resProfileAdmin?.admin_type === "programer";

    if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key === "I")) {
      if (!i) {
        e.preventDefault();
        console.warn("Keydown: DevTools access attempt by non-programer.");
      }
    }
  };

  render() {
    return null;
  }
}

export default DevToolsBlocker;
